<template>
    <div class="fileBox">
            <div class="file">

                <div v-if="!filename">
                <span style="text-decoration:underline">点击上传</span>
                <input type="file" id="myFile" ref="file" @change="handlerUpload($event)" />
                </div>
                <div v-else class="filesName">
                    {{filename}}
                </div>
                

           </div>
           <div v-if="filename" class="cleanOper">
                <div  style="width:100px;color: #0066FF; cursor:pointer;position:relative;z-index:10;text-decoration:underline" >重新上传
                    <input type="file" id="myFile" ref="file" @change="handlerUpload($event)"  style="opacity: 0; 
                    position: absolute;left:-5px;top:5px;width:90px;"/>
                </div>
                <div style="width:100px;color: #F5222D; cursor:pointer;text-decoration:underline" @click="file='',filename=''">删除</div>
           </div>
           <div class="aHref">
                <a
                    class="aHrefa"
                    @click.stop.self="handleExport"
                    :href="href"
                    >导入模板下载</a>
           </div>
       
            
    </div>
</template>
<script>
export default {
    props:['protocol','href','value'],
    data(){
        return {
            file:"",filename:""
        }
    },
     watch:{
            value:{
                immediate:true,
                handler:function(value){
                    if(!value){
                        this.file = "";
                        this.filename="";
                        return;
                    }

                }
            },
        },
    methods: {

         // 选择文件
    handlerUpload(e) {
      this.file = event.target.files[0];
      if (this.file == undefined) {
        this.filename = "";
        return;
      }
      this.filename = event.target.files[0].name;
      this.$emit("input",this.file)
      this.$emit("change",this.filename)
     
    },
        //  导入模板
    async handleExport(e) {
      if (this.protocol == "") {
        this.$message({
          message: "请先选择电池协议",
          type: "warning"
        });
        e.preventDefault();
      }
      return false;
    },
    },
    
    
}
</script>

<style scoped  lang="scss">
.fileBox{
    border: 1px dashed #CFD0D5;
    height: 144px;
}

.file {
  position: relative;
  padding: 5px 0px;
  overflow: hidden;
  color: #0066FF;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-left: 25px;
  margin-top: 16px;
}

.file input {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
}
.aHref{
    margin-left: 26px;
    color: #0066FF; 
    .aHrefa {
        font-size: 14px;
        color: #0066FF;
    }
    
}
.filesName{
    color: #000000;
}

.cleanOper{
    display: flex;
    width: 280px;
    height: 40px;
    margin-left: 26px;
    // justify-content: center;
   
    
}

</style>


// WEBPACK FOOTER //
// src/components/FSinglelmangeFile/index.vue